import React from "react";
import "./Hero.css";
import UpcomingEvents from "../UpcomingEvents/UpcomingEvents";

function Hero() {
  return (
    <section className="home-hero" id="home">
      <div className="home-hero__content">
        <p className="home-hero__eyebrow">
          <span aria-hidden="true"></span>
          VfB Johannesberg 1984 e.V.
        </p>

        <h1 className="home-hero__title">
          Sport, der uns <strong>verbindet.</strong>
        </h1>

        <p className="home-hero__text">
          Gemeinsam aktiv sein, Gemeinschaft erleben und zusammen mehr bewegen
          – in Bad Hersfeld.
        </p>

        <div className="home-hero__actions">
          <a href="#about" className="home-hero__primary-action">
            Verein kennenlernen
          </a>
          <a href="#weekly-program" className="home-hero__secondary-action">
            Wochenprogramm <span aria-hidden="true">→</span>
          </a>
        </div>
      </div>

      <div className="home-hero__event">
        <UpcomingEvents />
      </div>
    </section>
  );
}

export default Hero;
